// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext, useEffect, useMemo } from 'react';
import { AlertComponentProps } from 'react-alert'
import { useRouteMatch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import MemberContext from '../../contexts/MemberContext';

import S from './styles';

interface SnackbarProps extends AlertComponentProps {
  containerStyle?: React.CSSProperties;
}

const SnackbarTemplate = ({ options, message, containerStyle, close }: SnackbarProps):JSX.Element => {
  const member = useContext(MemberContext);
  const runningLabId = member.runningLab?.id;
  const runningLabPath = `/labs/${runningLabId}`
  const routeMatch = useRouteMatch(runningLabPath);
  const history = useHistory();
  const intl = useIntl();

  useEffect(() => {
    if (options.type === 'success' || options.type === 'info' || options.type === 'error') {
      const timeout = setTimeout(close, 5000)

      return () => {
        clearTimeout(timeout);
      }
    }
  }, [options.type])

  function handleContinue() {
    if (runningLabId && !routeMatch?.isExact) {
      history.push(runningLabPath);
    }
    close();
  }

  const translatedMessage = useMemo(() => {
    const id = message?.toString() || '';
    console.log(id)
    if (['E019', 'E017', 'E021', 'E069', 'E072', 'E073'].includes(id)) {
      return intl.formatMessage({ id })
    }

    return message;
  }, [message, intl.locale])

  function renderSnackBarLink(): JSX.Element | null {
    if (options.type === 'success') {
      return (<S.SnackbarLink onClick={handleContinue}>{intl.formatMessage({ id: 'E018' })}</S.SnackbarLink>)
    } else if (options.type === 'error') {
      return null;
      // return (<S.SnackbarLink ></S.SnackbarLink>)
    } else {
      return null;
      // return (<S.SnackbarLink onClick={close}></S.SnackbarLink>)
    }
  }

  return (
    <S.SnackbarBubble style={containerStyle}>
      <S.SnackbarIcon type={options.type} />
      <S.SnackbarMessage>{translatedMessage}</S.SnackbarMessage>
      {renderSnackBarLink()}
      <S.Close onClick={close}/>
    </S.SnackbarBubble>
  )
}

export default SnackbarTemplate;
